import type { SavedFlexiForward } from '@/domain/WorkspaceForex/savedProducts/flexi-forward/SavedFlexiForward';
import { generateEmptyFlexiForwardTile } from '@/store/flexi-forward/helpers/tile';
import type { FxFlexiForward } from '@/store/flexi-forward/state';

export function mapToFlexiForward({ tileId, properties, clientId }: SavedFlexiForward): FxFlexiForward {
  return generateEmptyFlexiForwardTile(
    tileId,
    {
      currencyPair: properties.currencyPair,
      notional: properties.notional,
      hedgeType: properties.hedgeType,
      clientsWay: properties.clientsWay,
      cutOffMarketPlace: properties.cutOffMarketPlace,
      deliveryDate: properties.deliveryDate,
      deltaHedgeAmount: properties.deltaHedgeAmount,
      deltaHedgeCurrencyIndex: properties.deltaHedgeCurrencyIndex,
      expiryDate: properties.expiryDate,
      marginCurrency: properties.marginCurrency,
      notionalCurrencyIndex: properties.notionalCurrencyIndex,
      premiumDate: properties.premiumDate,
      premiumType: properties.premiumType,
      premiumWay: properties.premiumWay,
      rate: properties.rate,
      solvingType: properties.solvingType,
      spotHedge: properties.spotHedge,
      startDate: properties.startDate,
      upfront: properties.upfront,
      upfrontCurrency: properties.upfrontCurrency,
    },
    clientId,
  );
}
